import { render, staticRenderFns } from "./SubMenu.vue?vue&type=template&id=7f8b3b82&scoped=true&"
import script from "./SubMenu.vue?vue&type=script&lang=js&"
export * from "./SubMenu.vue?vue&type=script&lang=js&"
import style0 from "./SubMenu.vue?vue&type=style&index=0&id=7f8b3b82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8b3b82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/s01-aiart-release-cn/s01_haiyiai_release-cn_aiart-web-openapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f8b3b82')) {
      api.createRecord('7f8b3b82', component.options)
    } else {
      api.reload('7f8b3b82', component.options)
    }
    module.hot.accept("./SubMenu.vue?vue&type=template&id=7f8b3b82&scoped=true&", function () {
      api.rerender('7f8b3b82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SubMenu.vue"
export default component.exports